import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=b6d9cc28&scoped=true&"
import script from "./categories.vue?vue&type=script&lang=js&"
export * from "./categories.vue?vue&type=script&lang=js&"
import style0 from "./categories.vue?vue&type=style&index=0&id=b6d9cc28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d9cc28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6d9cc28')) {
      api.createRecord('b6d9cc28', component.options)
    } else {
      api.reload('b6d9cc28', component.options)
    }
    module.hot.accept("./categories.vue?vue&type=template&id=b6d9cc28&scoped=true&", function () {
      api.rerender('b6d9cc28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/categories.vue"
export default component.exports